import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-confirm",
  "use": "icon-confirm-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-confirm\">\n<path d=\"M6.00068 11.8698L13.6021 4.26843C13.8767 3.99386 14.3219 3.99386 14.5964 4.26843C14.871 4.54304 14.871 4.98823 14.5964 5.26281L6.00067 13.8586L1.39343 9.25134C1.11886 8.97675 1.11886 8.53156 1.39343 8.25697C1.66803 7.98239 2.11321 7.98239 2.38781 8.25697L6.00068 11.8698Z\" fill=\"#2648FF\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol